import React from "react";

export function ViewLoanIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 82.7 52"
      width="82.7"
      height="52"
      {...props}
    >
      <g id="icons">
        <g id="view_loan_details" data-name="view loan details">
          <path
            className="cls-1"
            d="m41.35,52c-9.28,0-19.28-4.36-28.91-12.61C5.24,33.22.82,27.13.63,26.88l-.63-.88.63-.88c.18-.26,4.61-6.34,11.81-12.51C22.07,4.36,32.07,0,41.35,0s19.28,4.36,28.91,12.61c7.2,6.17,11.62,12.25,11.81,12.51l.63.88-.63.88c-.18.26-4.61,6.34-11.81,12.51-9.63,8.25-19.62,12.61-28.91,12.61ZM3.74,26c3.39,4.31,19.14,23,37.61,23s34.23-18.69,37.61-23c-3.39-4.31-19.14-23-37.61-23S7.12,21.69,3.74,26Z"
          />
          <circle className="cls-1" cx="40.85" cy="25.5" r="16" />
        </g>
      </g>
    </svg>
  );
}
